import { useTranslation } from 'react-i18next';
import { BadgeState, BadgeVariant, IconIdentifier, Tag, TagVariant } from '@steelbuy/ui-primitive';

interface RFQTeaserQualityProps {
    isDraft?: boolean;
}

export const RFQTeaserQuality = ({ isDraft }: RFQTeaserQualityProps) => {
    const { t } = useTranslation('uiDomain');

    if (isDraft) {
        return (
            <span className="draft-badgestate">
                <BadgeState label={t(`rfqDraftTeaser.draft`)} variant={BadgeVariant.INFO} />
            </span>
        );
    }
    return <Tag label={t('listingTeaserContainer.prime')} icon={IconIdentifier.PRIME} variant={TagVariant.PRIME} />;
};
